import axios from "axios";
import { getOptions } from "../../helpers/api";

export const elementClassification = {

  getIncidentImages: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/GetIncidentImages`, data.body, headers);
  },

  submitIncidentImageApproval: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/SubmitIncidentImageApproval`, data.body, headers);
  },

};
